import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import AccountTree from "@material-ui/icons/AccountTree";
import { Create, Edit, Identifier, linkToRecord, ReferenceInput, required, SelectArrayInput, SelectInput, SimpleForm, TextField, TextInput, useAuthProvider, useDataProvider, useListContext, useTranslate } from "react-admin";
import { Link } from 'react-router-dom';
import { BpmnField, BpmnInput, CustomTitle, DefaultToolbar, doChoices, GCloneButton, Legend, Loader, Row } from "../common/components";
import { useWidth, filterValue } from '../common/components/utils/fn';
import { getCols, workflowValidate } from "../services/workflow/actions";
import { List } from "@react-admin/ra-rbac";

export const WorkflowIcon = AccountTree;

export const WorkflowDisplay = props => {
    const p = { ...props };
    delete p["filterValue"];
    return <div>
        <TextField source="name" style={{ fontWeight: "bold" }} {...p} /><br />
        <TextField source="description" {...p} />
    </div>;
};

const GridList = () => {
    const translate = useTranslate();
    const [ref, width] = useWidth();
    const { ids, data, basePath } = useListContext();
    if (!ids || !data) return null;
    return (
        <ImageList cols={getCols(width)} rowHeight={300} gap={15} ref={ref}>
            {ids.map((id: Identifier) => {
                if (!data[id]) return <span key={id}></span>;
                return <ImageListItem key={id}>
                    <div className="vignette">
                        <Link to={linkToRecord(basePath, data[id].id)}>
                            <BpmnField source="model" record={data[id]} />
                        </Link>
                        <ImageListItemBar
                            title={data[id].name}
                            subtitle={data[id].description}
                            actionIcon={
                                <div className="wrap">
                                    {translate(`resources.status.${data[id].status}`)}
                                    <GCloneButton label="" title={translate("ra.action.clone")} variant="text" color="inherit" record={data[id]} />
                                </div>
                            }
                        />
                    </div>
                </ImageListItem>
            })
            }
        </ImageList >
    );
};

export const WorkflowList = props => {
    return <List className="transparentList" filters={[
        <TextInput source="name" alwaysOn />,
        <SelectArrayInput alwaysOn source="status" choices={doChoices.status} />,
        <ReferenceInput alwaysOn source="ownerId" reference="user" filter={{
            workflows: filterValue(null)
        }}>
            <SelectInput optionText="fullname" />
        </ReferenceInput>,
        <TextInput source="description" />
    ]} filterDefaultValues={{ status: ["enabled", "draft"] }} {...props}>
        <GridList />
    </List >
}

const WorkflowForm = props => {
    const authProvider = useAuthProvider();
    const dataProvider = useDataProvider();
    const ownerId = authProvider?.getId();
    if (!ownerId) return <Loader />;
    return <SimpleForm {...props} initialValues={{ ownerId }} toolbar={<DefaultToolbar hasDuplicate onActivate={workflowValidate(dataProvider, props.record.model, props.record.id)} />}>
        <Legend />
        <Row>
            <TextInput source="name" validate={[required()]} />
            <SelectInput source="status" choices={doChoices.status} defaultValue="draft" disabled />
            <ReferenceInput disabled source="ownerId" reference="user" validate={[required()]}>
                <SelectInput optionText="fullname" />
            </ReferenceInput>
        </Row>
        <TextInput source="description" multiline />
        <BpmnInput source="model" {...props} />
    </SimpleForm>
}

export const WorkflowEdit = (props) =>
    <Edit {...props} title={<CustomTitle title="workflow" />}>
        <WorkflowForm />
    </Edit>;

export const WorkflowCreate = props =>
    <Create {...props}>
        <WorkflowForm />
    </Create>